// extracted by mini-css-extract-plugin
module.exports = {"page":"ServerErrorPage_page__X4cjC"};